import React, { useState } from 'react';
import { ENTITIES } from '../../../constants';
import { useEntityList } from '../../../hooks/useEntityList';
import MonthSelector from '../../MonthSelector';
import ExportToExcel from '../ExportToExcel';
import EntityTable from '../EntityTable';
import EntityEditForm from '../EntityEditForm';

const MemberFeesTab = ({
  selectedDate,
  setSelectedDate,
  lang,
  userEmail,
  getOptionLabel,
  memberTypeNames
}) => {
  const entity = ENTITIES.memberFees;
  const [fields, setFields] = useState();
  const [showForm, setShowForm] = useState(null);

  const { items, isLoading, error, reload, updateItem } = useEntityList(
    entity,
    selectedDate,
    userEmail
  );

  const handleEditItem = (item) => {
    setFields(item);
    setShowForm('edit');
  };

  return (
    <>
      {error && (
        <div className="error-banner card wrapper-width flex flex-align-center-v" style={{ background: '#ffebee', color: '#c62828', padding: '10px 20px', margin: '10px auto', borderRadius: '4px', justifyContent: 'space-between' }}>
          <span>{error}</span>
          <button className="button" style={{ marginLeft: '15px', padding: '4px 10px' }} onClick={reload}>Retry</button>
        </div>
      )}

      <div className="flex center wrapper-width-small">

        <div className="card card-large padding-card-small width-max-content position-relative member-bookings-bar">

          <div className='position-relative'>
            <MonthSelector
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                lang={lang}
            />
            <ExportToExcel
                data={items}
                selectedDate={selectedDate}
            />
          </div>

          <ul id="items-list" className={`${entity.listAction}`}>
            {isLoading ? (
              <div className="spinner"></div>
            ) : (
              <EntityTable
                items={items}
                columns={entity.columns}
                schema={entity.schema}
                listType={entity.listAction}
                getOptionLabel={getOptionLabel}
                onEdit={handleEditItem}
                canEdit={true}
                canDelete={false}
                allMemberTypeNames={memberTypeNames}
              />
            )}
          </ul>

        </div>

        <div id="items-list-edit" className={`width-max-content card card-large padding-card-small ${showForm ? 'fade-in' : 'fade-out'}`} style={{ marginLeft: '20px' }}>
          {showForm === 'edit' && fields && (
            <div key={`edit-${fields?.email || fields?.id || 'edit'}`} className="fade-in">
              <EntityEditForm
                fields={fields}
                schema={entity.schema}
                onSaveField={async (field, val) => {
                  const conditionVal = fields.email;
                  await updateItem(conditionVal, field, val);
                  setFields(prev => ({ ...prev, [field]: val }));
                }}
                getOptionLabel={getOptionLabel}
                listType={entity.listAction}
                selectedDate={selectedDate}
                memberTypeNames={memberTypeNames}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MemberFeesTab;
export { MemberFeesTab };
